import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DictionaryContractType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { base64StringToBlob } from 'blob-util';
import { DocumentExportAPIService } from 'src/app/extensions/services/api/documentExport-api.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { DocumentExport } from 'src/app/extensions/services/api/events';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { LoaderService } from 'src/app/extensions/services/loader.service';
import { FileStoreAPIService } from 'src/app/extensions/services/api/file-store-api.service';
import { TIMEOUT_EVENT_TYPE } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'contract-detail-payment-schedule',
  templateUrl: './contract-detail-payment-schedule.component.html',
  styleUrls: ['./contract-detail-payment-schedule.component.scss'],
  standalone: false,
})
export class ContractDetailPaymentScheduleComponent {
  hidePdfButton: boolean;
  hideXlsButton: boolean;
  public constructor(
    private _router: Router,
    private _documentExportAPIService: DocumentExportAPIService,
    private _notificationService: NotificationService,
    private _translateService: TranslateService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvConfigurationData,
    private _loaderService: LoaderService
  ) {
    this.hidePdfButton = JSON.parse(this._envConfig.CONFIG_HIDE_DOWNLOAD_PAYMENTSCHEDULE_PDF || 'false');
    this.hideXlsButton = JSON.parse(this._envConfig.CONFIG_HIDE_DOWNLOAD_PAYMENTSCHEDULE_XLS || 'false');
  }

  @Input() paymentSchedules: app.models.ContractDetailPaymentScheduleModel[];
  @Input() props: app.models.DynamicPropsDictionary;
  @Input() contract: app.models.ContractDetailModel;

  ContractType = DictionaryContractType;
  @Input() contractId: string;

  public invoiceHandler(invoiceId: string) {
    this._router.navigate(['invoices', invoiceId]);
  }

  exportHandler(exportAs: string) {
    this._loaderService.isLoadingForced.next(true);
    this._documentExportAPIService.exportContractPaymentSchedule(this.contractId, exportAs).subscribe(result => {
      if (result.isSuccess) {
        const event = result.response.events.find(x => x.eventType == DocumentExport.ContractPaymentScheduleFileSaved);
        if (event.eventBody) {
          //Download is trigger by signalR
        }

        const eventUploadedFile = result.response.events.find(
          x => x.eventType == DocumentExport.ContractPaymentScheduleExported
        );
        if (eventUploadedFile && eventUploadedFile.eventBody) {
          const uploadedFile = eventUploadedFile.eventBody.uploadedFile;
          const dateTime = new Date();
          const date = dateTime.getFullYear() + '-' + (dateTime.getMonth() + 1) + '-' + dateTime.getDate();
          const time = dateTime.getHours() + '-' + dateTime.getMinutes() + '-' + dateTime.getSeconds();
          const generatedFileName = `c_${date}_${time}`;
          const blob = base64StringToBlob(uploadedFile.buffer, uploadedFile.contentType);
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = `${generatedFileName}.${uploadedFile.contentType}`;
          downloadLink.click();
        }
      } else if (result.response.events.some(x => x.eventType == TIMEOUT_EVENT_TYPE)) {
        this._notificationService.showInfo(
          this._translateService.instant('contractDetail.paymentSchedule.exportLongTimeWarning'),
          this._translateService.instant('common.warning')
        );
      } else {
        this._notificationService.showError(
          this._translateService.instant('contractDetail.paymentSchedule.paymentScheduleExportFailed'),
          this._translateService.instant('common.error')
        );
      }

      this._loaderService.isLoadingForced.next(false);
    });
  }
}
